import { toNumber } from "./toNumber";

// toNumber chokes on "" / null / undefined, and every total below multiplies
// through, so one NaN would poison the whole invoice.
export const num = (value) => toNumber(value || 0) || 0;

/**
 * The invoice money math, in one place so the form only has to place the
 * results: net_price = price - discount, the line total is net_price * quantity,
 * and the invoice total is the sum of the lines minus the invoice-level
 * discount (the backend stores total_amount already net).
 */
export const invoiceTotals = (items = [], invoiceDiscount = 0) => {
  const lines = (items ?? []).map((item) => {
    const net_price = num(item.price) - num(item.discount);
    return { net_price, total_amount: net_price * num(item.quantity) };
  });
  return {
    lines,
    total_amount:
      lines.reduce((sum, line) => sum + line.total_amount, 0) -
      num(invoiceDiscount),
  };
};
